import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';

@Component({
  selector: 'app-meilleurs-bien-monastir',
  templateUrl: './meilleurs-bien-monastir.component.html',
  styleUrls: ['./meilleurs-bien-monastir.component.scss']
})
export class MeilleursBienMonastirComponent implements OnInit {

  public MeilleursBiens: any
  p: Number = 1;
  dataSource = new MatTableDataSource();

  constructor(private meilleursBiensService: MeilleursBiensService) { }

 ngOnInit(): void {
  this.getMeilleursBiensMonastir();
     
  }
  getMeilleursBiensMonastir() {
    this.meilleursBiensService.getMeilleursBiensMonastir().subscribe((data: any) => {
    
      this.MeilleursBiens = data;
     
        console.log('meilleurs biens monastir',this.MeilleursBiens)
         

    })
  }

  


  SupprimerMeilleursBiens(MeilleursBiens: any) {
    this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
 

  }

}
